module.exports = __webpack_public_path__ + "static/hero-3c2d2bfe17277a313910e870a6a3bf60.jpg";